export const removeDuplicateArrayOfObj = ({arraywithDuplicateObj}) => {
    const afterremovedDuplicate = arraywithDuplicateObj?.filter(
        (rmvItem, rmvIndex, self) => rmvIndex === self.findIndex(obj => obj.value === rmvItem.value)
    );
    return afterremovedDuplicate;
} 